/*ReactJS*/
import React from 'react';

/*Material UI Components*/
import { Typography, Breadcrumbs, Box } from '@material-ui/core';

/*Styles*/
import useStyles from '../../styles';

/*Table Components*/
import SettlementFundingTable from './Components/SettlementFundingTable';

export default function SettlementFunding(props) {
  const classes = useStyles();

  return (
    <React.Fragment>
      <div className={classes.pageContainer}>
        <Box>
          <Typography
            variant="h2"
            className={classes.textBold}
            align="left"
            gutterBottom={true}
          >
            Settlement Funding
          </Typography>
          <Breadcrumbs aria-label="breadcrumb">
            <span color="inherit">Balance</span>
            <span color="inherit">Cash</span>
            <Typography color="primary">Settlement Funding</Typography>
          </Breadcrumbs>
        </Box>
        <Box mt={2}>
          <SettlementFundingTable params={props} />
        </Box>
      </div>
    </React.Fragment>
  );
}
